import { useEffect } from 'react';
import { useSearchState } from '@vtex/admin-ui';
import { SearchBarProps } from './search-bar.component';

export const useSearchBar = ({ onSearch }: SearchBarProps) => {
  const search = useSearchState();

  useEffect(() => {
    onSearch(search.debouncedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search.debouncedValue]);

  return { search };
};
